import { Navigate } from 'react-router-dom';
import { useStore } from '@hooks/useStore';
import { FeatureFlagName } from '@/interfaces/User.interface';
import { ProtectedRouteProps } from './types';
import { AuthSessionGate } from './AuthSessionGate';

interface FeatureProtectedProps extends ProtectedRouteProps {
  flag: FeatureFlagName;
  /**
   * Market Intelligence write routes. SEG tenants pass via `tenant_is_seg_parent`
   * (the CRM grants `mi:write` from view + SEG). Manage permission and `mi:write`
   * stay as fixture fallbacks because `market_intelligence_manage` is not in the API.
   */
  requireSegParent?: boolean;
}

const FeatureProtected = ({
  permissions,
  element,
  flag,
  requireSegParent = false
}: FeatureProtectedProps) => {
  const { authStore } = useStore();
  const { hasPermission, hasFeature } = authStore;

  const passesSegParentGate =
    !requireSegParent ||
    Boolean(authStore.user?.company?.tenant_is_seg_parent) ||
    hasPermission(['market_intelligence_manage']) ||
    Boolean(authStore.user?.scopes?.includes('mi:write'));

  const canAccessFeature =
    hasFeature(flag) && hasPermission(permissions) && passesSegParentGate;

  return (
    <AuthSessionGate>
      {canAccessFeature ? element ?? null : (
        <Navigate to="/dashboard" replace />
      )}
    </AuthSessionGate>
  );
};

export default FeatureProtected;
